module.exports = __webpack_public_path__ + "img/process-small5.60b89fd2.png";